export default __webpack_public_path__ + "static/media/profileImage.9e6fef5c.png";